export const paymentScheduleFieldStyles = {
  container: {
    width: '100%',
  },
  
  title: {
    mb: 2,
    fontWeight: 600,
    color: 'text.primary',
  },
  
  tableContainer: {
    mb: 2,
    borderRadius: 2,
    boxShadow: (theme) => theme.palette.mode === 'dark' ? 3 : 1,
    backgroundColor: 'background.paper',
  },
  
  table: {
    '& .MuiTableCell-root': {
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
    },
  },
  
  tableHead: {
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'grey.800' : 'grey.50',
    '& .MuiTableCell-root': {
      fontWeight: 600,
      color: 'text.primary',
      borderBottom: '2px solid',
      borderBottomColor: 'primary.main',
    },
  },
  
  monthCell: {
    fontWeight: 500,
    color: 'text.primary',
  },
  
  paymentDayCell: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '40px',
    px: 1,
    borderRadius: 1,
    backgroundColor: 'success.light',
    color: 'success.contrastText',
    fontWeight: 500,
  },
  
  paymentDayCellInactive: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '40px',
    px: 1,
    borderRadius: 1,
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'grey.700' : 'grey.100',
    color: 'text.secondary',
  },
  
  activeCell: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '40px',
    px: 1,
    borderRadius: 1,
    backgroundColor: 'success.light',
    color: 'success.contrastText',
    fontWeight: 500,
  },
  
  activeCellInactive: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '40px',
    px: 1,
    borderRadius: 1,
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'grey.700' : 'grey.100',
    color: 'text.secondary',
  },
  
  amountInput: {
    width: 120,
    '& .MuiInputBase-input': {
      textAlign: 'right',
    },
  },
  
  amountInputDisabled: {
    width: 120,
    opacity: 0.5,
    '& .MuiInputBase-input': {
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'grey.700' : 'grey.100',
      textAlign: 'right',
    },
  },
  
  amountInputTransferred: {
    width: 120,
    opacity: 0.5,
    '& .MuiInputBase-input': {
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'grey.700' : 'grey.100',
      textDecoration: 'line-through',
      textAlign: 'right',
    },
  },
  
  transferInfo: {
    display: 'block',
    mt: 0.5,
    color: 'text.secondary',
    fontSize: '0.75rem',
  },
  
  transferModeBox: {
    p: 2,
    mb: 2,
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'primary.dark' : 'primary.light',
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'primary.main',
  },
  
  transferModeText: {
    color: (theme) => theme.palette.mode === 'dark' ? 'primary.light' : 'primary.dark',
    '& strong': {
      fontWeight: 600,
    },
  },
  
  summaryChips: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    mb: 1,
  },
  
  activePeriodsChip: {
    color: 'primary.main',
    borderColor: 'primary.main',
  },
  
  totalChip: {
    color: 'success.main',
    borderColor: 'success.main',
  },
  
  errorText: {
    mt: 1,
    display: 'block',
    color: 'error.main',
  },
  
  transferButton: {
    backgroundColor: 'success.light',
    color: 'success.contrastText',
    '&:hover': {
      backgroundColor: 'success.main',
      color: 'success.contrastText',
    },
  },
  
  cancelButton: {
    color: 'error.main',
    '&:hover': {
      backgroundColor: 'error.light',
      color: 'error.contrastText',
    },
  },
  
  startTransferButton: {
    color: 'primary.main',
    '&:hover': {
      backgroundColor: 'primary.light',
      color: 'primary.contrastText',
    },
  },
  
  noteText: {
    mt: 2,
    p: 1.5,
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'warning.dark' : 'warning.light',
    color: (theme) => theme.palette.mode === 'dark' ? 'warning.contrastText' : 'warning.dark',
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'warning.main',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
};
